/**
 * Shared route constants used by main layout components.
 */
export const LAYOUT_ROUTES = {
    DASHBOARD: '/dashboard',
    PROFILE_SETTINGS: '/profile-settings',
} as const;
